import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import './style.css';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function Forms() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={3}></Grid>
        <Grid item xs={12} sm={6}>
          <h4>Após se cadastrar, você receberá por e-mail a sua senha. O seu e-mail será o seu login.</h4>
          <br></br>
          <form id="PS-Cadastro-Medico-Tutor-Form">
            <p id="PS-Title-Cadastro-Medico-Tutor" >Nome</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Medico-Tutor-Forms" />
            <p id="PS-Title-Cadastro-Medico-Tutor" >CRM</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Medico-Tutor-Forms" />
            <p id="PS-Title-Cadastro-Medico-Tutor" >CPF</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Medico-Tutor-Forms" />
            <p id="PS-Title-Cadastro-Medico-Tutor" >Telefone</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Medico-Tutor-Forms" />
            <p id="PS-Title-Cadastro-Medico-Tutor" >Endereço</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Medico-Tutor-Forms" />
            <p id="PS-Title-Cadastro-Medico-Tutor" >RG</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Medico-Tutor-Forms" />
            <p type="ratio" id="PS-Title-Cadastro-Medico-Tutor">Especialidade</p>
            <select id="PS-Cadastro-Medico-Tutor-Forms">
              <option value="1">Opçao 1</option>
              <option value="2">Opção 2</option>
              <option selected value="3">Opção 3</option>
              <option value="4">Opçao 4</option>
            </select>
            <br></br>
            <p id="PS-Title-Cadastro-Medico-Tutor">Tipo de Voluntariado</p>
            <select id="PS-Cadastro-Medico-Tutor-Forms">
              <option value="1">Disponho-me para atendimento inloco</option>
              <option value="2">Disponho-me para telemonitoração e orientação de demais profissionais e alunos</option>
              <option selected value="3">Estudante de medicina ou enfermagem</option>
              <option value="4">Outra área da saúde</option>
            </select>
            <br></br>
            <Button variant="contained" id="exit-PS-Cadastro-Medico-Tutor"  onClick={alert("Funcionalidade ainda não disponível, entre em contato com Organizador!")} >Enviar</Button>
          </form>
        </Grid>
        <Grid item xs={12} sm={3}>
        </Grid>
      </Grid>
    </div>
  );
}
